import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { API_URL, BASE_URL, PASSWORD, USERNAME } from "../../constants";
import axios from "axios";
import Header from "../Layouts/Header";
import Sidebar from "../Layouts/Sidebar";
import { getApiAction, productAddedMain } from "../../Utils/helper";
import { useDispatch } from "react-redux";
import ProductItem from "./ProductItem";

const Products = () => {
  const { id: category_id } = useParams();

  const bannerStyle = {
    backgroundImage: `url(${BASE_URL}/assets/images/submenu_Bg.png)`,
  };

  const [subCatResponseData, setSubCatResponseData] = useState(null);
  //const [catResponseData, setCatResponseData] = useState(null);
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  
  const tagStyle = {
    "width": `calc(100% / ${subCatResponseData?.classification_tags?.length})`
  };
  useEffect(() => {
      const fetchData = async (cId) => {
        try {
          /*let catResponse = await getApiAction("products/categories", {}, 0, dispatch);

          setCatResponseData(catResponse);*/
          let subCatResponse = await getApiAction("products?category_id=" + category_id, {}, 0, dispatch);
          setSubCatResponseData(subCatResponse?.products);
          setActiveTab(0)
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      setTimeout(() => {
        fetchData(category_id);
      }, 100);

    return () => {
      // setSubCatResponseData(null);
    };
  }, [category_id]);

  const changeTab = (menu) => {
    setActiveTab(menu)
  };

  return (
    <div>
      <div className="wrapper">
        {/* START category_wrapper */}
        <div className="category_wrapper" style={bannerStyle}>
          {/* START headerSite */}
          <Header />
          {/* END headerSite */}

          <div className="pageContainer">
           <Sidebar />
            {/* START category_ContentArea */}
            <div className="category_ContentArea sub_categoryPart">
              <div className="sub_categoryBox">
                <h2>{subCatResponseData?.category_name}</h2>
                <div className="tabsContantArea homeTabContantPart">

                  <ul className="nav nav-tabs nav-justified mb-5" id="ex1" role="tablist">
                    {subCatResponseData?.classification_tags?.map((item, idex) => (
                      <li className="nav-item" role="presentation" style={tagStyle} >
                          <a className={activeTab == idex ? 'nav-link active': 'nav-link'} onClick={() => {changeTab(idex) }} id={'#ex3-tab-'+idex} data-bs-toggle="tab" href={'#ex3-tabs-'+idex} role="tab" aria-controls={'#ex3-tabs-'+idex} aria-selected="true">{item}</a>
                      </li>
                    ))}
                  </ul>

                  <div className="tab-content" id="ex2-content">
                  {subCatResponseData?.classification_tags?.map((catitem, idex) => (
                    <div className={activeTab == idex ? 'tab-pane fade show active': 'tab-pane fade'} id={'#ex3-tabs-'+idex} role="tabpanel" aria-labelledby={'#ex3-tab-'+idex}>
                      <div className="detailcategoryBox">
                        {subCatResponseData?.data?.map((item) => (
                          <>
                          {item?.categories?.find(e => e.classification_tag === catitem) ? (
                            <>
                          <ProductItem key={item.id} item={item} />
                          </>
                           ) : (
                            <></>
                           )}
                           </>
                          ))}
                      </div>
                    </div>
                    ))}
                    
                  </div>
                </div>
              </div>
            </div>
            {/* END category_ContentArea */}
          </div>
        </div>
        {/* END category_wrapper */}
      </div>
    </div>
  );
};

export default Products;
